var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85342 6.8539L0.853232 12.8534C0.755896 12.9507 0.627872 13 0.499868 13C0.371864 13 0.243841 12.9514 0.146505 12.8534C-0.0488349 12.658 -0.0488349 12.3414 0.146505 12.1461L5.79337 6.49993L0.146505 0.853781C-0.0488349 0.658465 -0.0488349 0.341803 0.146505 0.146487C0.341844 -0.048829 0.658544 -0.048829 0.853883 0.146487L6.85407 6.14595C7.04874 6.34194 7.04876 6.65858 6.85342 6.8539Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.5986fe93.svg";
export { ForwardRef as ReactComponent };